import { defineMessages } from '@formatjs/intl';

import {
	MentalHealthSectionTitle,
	MentalHealthSlide,
} from '@/components/homepageRefresh/homepage/MentalHealthTools/types';

export const messages = defineMessages({
	heading: {
		id: 'subpage.sleep.mentalHealthTools.heading',
		defaultMessage: 'The easiest way to get deep sleep.',
		description: 'Heading for section with the various mental health tools that Calm provides',
	},
	slide1Title: {
		id: 'subpage.sleep.mentalHealthTools.slide1.title',
		defaultMessage: 'Sleep Stories',
		description: 'Title for mental health tools slide',
	},
	slide1Heading: {
		id: 'subpage.sleep.mentalHealthTools.slide1.heading',
		defaultMessage: 'Bedtime stories for grownups',
		description: 'Heading for mental health tools slide',
	},
	slide1Copy: {
		id: 'subpage.sleep.mentalHealthTools.slide1.copy',
		defaultMessage:
			'Sleep Stories will guide you off to sleep quickly and naturally. Choose from 300+ titles, which includes celebrated voices like Matthew McConaughey, Idris Elba, and Jennifer Garner.',
		description: 'Copy for mental health tools slide',
	},
	slide1ContentTitle: {
		id: 'subpage.sleep.mentalHealthTools.slide1.contentTitle',
		defaultMessage: 'Dream with Me',
		description: "Title of slide's previewable content",
	},
	slide1ContentSubheading: {
		id: 'subpage.sleep.mentalHealthTools.slide1.contentSubheading',
		defaultMessage: 'Fall asleep and fall in love with the dreamy voice of Harry Styles.',
		description: "Information for slide's previewable content",
	},
	slide1ContentAuthor: {
		id: 'subpage.sleep.mentalHealthTools.slide1.contentAuthor',
		defaultMessage: 'Narrated by Harry Styles',
		description: "Author of slide's previewable content",
	},
	slide2Title: {
		id: 'subpage.sleep.mentalHealthTools.slide2.title',
		defaultMessage: 'Sleep Meditations',
		description: 'Title for mental health tools slide',
	},
	slide2Heading: {
		id: 'subpage.sleep.mentalHealthTools.slide2.heading',
		defaultMessage: 'A bit of guidance to help you drift off',
		description: 'Heading for mental health tools slide',
	},
	slide2Copy: {
		id: 'subpage.sleep.mentalHealthTools.slide2.copy',
		defaultMessage:
			"Pick a dreamy voice, and they'll take it from there. Calm's Sleep Meditations work with mindfulness tools and themes, like body scans, gratitude, and progressive muscle relaxation.",
		description: 'Copy for mental health tools slide',
	},
	slide2ContentTitle: {
		id: 'subpage.sleep.mentalHealthTools.slide2.contentTitle',
		defaultMessage: 'Unwind Into Sleep',
		description: "Title of slide's previewable content",
	},
	slide2ContentSubheading: {
		id: 'subpage.sleep.mentalHealthTools.slide2.contentSubheading',
		defaultMessage: 'Release tension and ease into sleep using breath work and body awareness',
		description: "Information for slide's previewable content",
	},
	slide2ContentAuthor: {
		id: 'subpage.sleep.mentalHealthTools.slide2.contentAuthor',
		defaultMessage: 'Narrated by Chibs Okereke',
		description: "Author of slide's previewable content",
	},
	slide3Title: {
		id: 'subpage.sleep.mentalHealthTools.slide3.title',
		defaultMessage: 'Music',
		description: 'Title for mental health tools slide',
	},
	slide3Heading: {
		id: 'subpage.sleep.mentalHealthTools.slide3.heading',
		defaultMessage: 'Soothing melodies designed for sleep',
		description: 'Heading for mental health tools slide',
	},
	slide3Copy: {
		id: 'subpage.sleep.mentalHealthTools.slide3.copy',
		defaultMessage:
			'Calm Music puts relaxation at your fingertips. Explore a universe of soothing sounds and genres, including celebrated artists like Moses Sumney and Tom Middleton.',
		description: 'Copy for mental health tools slide',
	},
	slide3ContentTitle: {
		id: 'subpage.sleep.mentalHealthTools.slide3.contentTitle',
		defaultMessage: '432 Hz for Sleep',
		description: "Title of slide's previewable content",
	},
	slide3ContentSubheading: {
		id: 'subpage.sleep.mentalHealthTools.slide3.contentSubheading',
		defaultMessage: 'Carefully crafted piano melodies tuned to 432 Hz for deep relaxation',
		description: "Information for slide's previewable content",
	},
	slide4Title: {
		id: 'subpage.sleep.mentalHealthTools.slide4.title',
		defaultMessage: 'Soundscapes',
		description: 'Title for mental health tools slide',
	},
	slide4Heading: {
		id: 'subpage.sleep.mentalHealthTools.slide4.heading',
		defaultMessage: 'A sonic pathway to dreamland',
		description: 'Heading for mental health tools slide',
	},
	slide4Copy: {
		id: 'subpage.sleep.mentalHealthTools.slide4.copy',
		defaultMessage:
			'Calm has curated the most soothing sounds on Earth. Explore a different nature scene every night, and try our popular white noise, green noise, and brown noise soundscapes.',
		description: 'Copy for mental health tools slide',
	},
	slide4ContentTitle: {
		id: 'subpage.sleep.mentalHealthTools.slide4.contentTitle',
		defaultMessage: 'Rain on Leaves',
		description: "Title of slide's previewable content",
	},
	slide4ContentSubheading: {
		id: 'subpage.sleep.mentalHealthTools.slide4.contentSubheading',
		defaultMessage: 'Soothing sounds of rainfall',
		description: "Information for slide's previewable content",
	},
	slide5Title: {
		id: 'subpage.sleep.mentalHealthTools.slide5.title',
		defaultMessage: 'Sleep Tracking',
		description: 'Title for mental health tools slide',
	},
	slide5Heading: {
		id: 'subpage.sleep.mentalHealthTools.slide5.heading',
		defaultMessage: 'A toolkit to get your sleep on track',
		description: 'Heading for mental health tools slide',
	},
	slide5Copy: {
		id: 'subpage.sleep.mentalHealthTools.slide5.copy',
		defaultMessage:
			'Our sleep tracking tools make it easy to build the habits of healthy sleep. Log your nightly hours, monitor your sleep quality, and create a bedtime routine that works for you.',
		description: 'Copy for mental health tools slide',
	},
	slide5ContentTitle: {
		id: 'subpage.sleep.mentalHealthTools.slide5.contentTitle',
		defaultMessage: 'A new way to track your sleep',
		description: "Title of slide's previewable content",
	},
	slide5ContentSubheading: {
		id: 'subpage.sleep.mentalHealthTools.slide5.contentSubheading',
		defaultMessage: 'Reflect on your nightly sleep quality and what might have affected it',
		description: "Information for slide's previewable content",
	},
	slide6Title: {
		id: 'subpage.sleep.mentalHealthTools.slide6.title',
		defaultMessage: 'For Kids',
		description: 'Title for mental health tools slide',
	},
	slide6Heading: {
		id: 'subpage.sleep.mentalHealthTools.slide6.heading',
		defaultMessage: 'Bedtime can be a blast',
		description: 'Heading for mental health tools slide',
	},
	slide6Copy: {
		id: 'subpage.sleep.mentalHealthTools.slide6.copy',
		defaultMessage:
			'Getting your kids to bed will never be the same. Our Sleep Stories for kids feature characters your little ones will know and love, like Transformers, My Little Pony, Minions, and many more.',
		description: 'Copy for mental health tools slide',
	},
	slide6ContentTitle: {
		id: 'subpage.sleep.mentalHealthTools.slide6.contentTitle',
		defaultMessage: 'Winnie the Pooh',
		description: "Title of slide's previewable content",
	},
	slide6ContentSubheading: {
		id: 'subpage.sleep.mentalHealthTools.slide6.contentSubheading',
		defaultMessage: 'Drift off to sleep while Tom Hiddleston reads you a classic story ',
		description: "Information for slide's previewable content",
	},
	slide6ContentAuthor: {
		id: 'subpage.sleep.mentalHealthTools.slide6.contentAuthor',
		defaultMessage: 'Narrated by Tom Hiddleston',
		description: "Author of slide's previewable content",
	},
});

export const sections: Record<MentalHealthSectionTitle, MentalHealthSlide> = {
	sleepStories: {
		title: messages.slide1Title,
		heading: messages.slide1Heading,
		copy: messages.slide1Copy,
		contentTitle: messages.slide1ContentTitle,
		contentSubheading: messages.slide1ContentSubheading,
		contentUrl: '/app/player/2QQEAZ7IsG',
		author: messages.slide1ContentAuthor,
		imageUrl: '/_n/images/subpages/sleep-player-harry.webp',
		audioSrc: '/_n/audio/subpages/SLEP_0184_DreamWithMe_EN_2CH_MK_20230802_HomepageCutdown.mp3',
	},
	sleepMeditations: {
		title: messages.slide2Title,
		heading: messages.slide2Heading,
		copy: messages.slide2Copy,
		contentTitle: messages.slide2ContentTitle,
		contentSubheading: messages.slide2ContentSubheading,
		contentUrl: '/app/player/YF7qttMols',
		author: messages.slide2ContentAuthor,
		imageUrl: '/_n/images/subpages/sleep-player-meditation.webp',
		audioSrc: '/_n/audio/subpages/MSLP_1007_UnwindIntoSleep_EN_2CH_MK_20230802_HomepageCutdown.mp3',
	},
	music: {
		title: messages.slide3Title,
		heading: messages.slide3Heading,
		copy: messages.slide3Copy,
		contentTitle: messages.slide3ContentTitle,
		contentSubheading: messages.slide3ContentSubheading,
		contentUrl: '/app/player/24TtZ8H-SC',
		imageUrl: '/_n/images/subpages/sleep-player-music.webp',
		audioSrc: 'https://assets.calm.com/29e980d4f8cd3896cc4eab08ac77aedd.m4a',
	},
	soundscapes: {
		title: messages.slide4Title,
		heading: messages.slide4Heading,
		copy: messages.slide4Copy,
		contentTitle: messages.slide4ContentTitle,
		contentSubheading: messages.slide4ContentSubheading,
		imageUrl: '/_n/images/subpages/sleep-player-relaxation.webp',
		audioSrc: '/_n/audio/subpages/SSPS_0020_RainOnLeaves_2CH_MK_20230802_HomepageCutdown.mp3',
	},
	sleepTracking: {
		title: messages.slide5Title,
		heading: messages.slide5Heading,
		copy: messages.slide5Copy,
		contentTitle: messages.slide5ContentTitle,
		contentSubheading: messages.slide5ContentSubheading,
		contentUrl: '/app/player/2QQEAZ7IsG',
		imageUrl: '/_n/images/subpages/sleep-player-tracking.webp',
	},
	forKids: {
		title: messages.slide6Title,
		heading: messages.slide6Heading,
		copy: messages.slide6Copy,
		contentTitle: messages.slide6ContentTitle,
		contentSubheading: messages.slide6ContentSubheading,
		author: messages.slide6ContentAuthor,
		imageUrl: '/_n/images/subpages/sleep-player-winnie.webp',
		audioSrc: '/_n/audio/subpages/SLEP_0326_WinnieThePooh_EN_2CH_MK_20230802_HomepageCutdown.mp3',
	},
};
